// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* player.css */

[data-media-player][data-layout='video'] {
    background-color: transparent !important; /* Or any other color you prefer */
}

.video-player-features-page {
    width: 50%;
    position: relative;
}

@media (max-width: 768px) {
    .video-player-features-page {
        width: 100%;
        margin-top: 7vw;
    }
}

@media (max-width: 991px) {
    .video-player-features-page {
        width: 100%;
        margin-top: 7vw;
    }
}

.video-player {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

/* Hide default controls initially */
.video-player .vds-controls {
    display: none;
    position: absolute;
    bottom: 0;
    width: 100%;
}

/* Central play button */
.video-player .central-play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 4rem;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 25px 25px;
    border-radius: 25%;
    cursor: pointer;
    z-index: 10;
}

.video-player .central-play-button:hover {
    background: rgba(255, 255, 255, 0.34);
}

/* Hide central play button when video is playing */
.video-player .central-play-button.hidden {
    display: none;
}

/* Show default controls when video is playing */
.video-player.playing .vds-controls {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/video-player-styling/player.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,wCAAwC,EAAE,kCAAkC;AAChF;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA,mDAAmD;AACnD;IACI,aAAa;AACjB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf","sourcesContent":["/* player.css */\n\n[data-media-player][data-layout='video'] {\n    background-color: transparent !important; /* Or any other color you prefer */\n}\n\n.video-player-features-page {\n    width: 50%;\n    position: relative;\n}\n\n@media (max-width: 768px) {\n    .video-player-features-page {\n        width: 100%;\n        margin-top: 7vw;\n    }\n}\n\n@media (max-width: 991px) {\n    .video-player-features-page {\n        width: 100%;\n        margin-top: 7vw;\n    }\n}\n\n.video-player {\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n}\n\n/* Hide default controls initially */\n.video-player .vds-controls {\n    display: none;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n\n/* Central play button */\n.video-player .central-play-button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 4rem;\n    background: rgba(0, 0, 0, 0.5);\n    color: white;\n    padding: 25px 25px;\n    border-radius: 25%;\n    cursor: pointer;\n    z-index: 10;\n}\n\n.video-player .central-play-button:hover {\n    background: rgba(255, 255, 255, 0.34);\n}\n\n/* Hide central play button when video is playing */\n.video-player .central-play-button.hidden {\n    display: none;\n}\n\n/* Show default controls when video is playing */\n.video-player.playing .vds-controls {\n    display: flex;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
